import React from "react";
import { Box, Chip, Typography, Stack } from "@mui/material";
import LGModalCrud from "../LGCrud/LGModalCrud";
import { useCompany } from "../../contexts/CompanyContext";
import OutboundForm from "./OutboundForm.tsx";
import dayjs from "dayjs";
import { deleteOutbound, getOutboundList, updateOutboundStatus } from "../../api/outbounds/index.ts";
import StatusManager from "../../molecules/Inventory/StatusManager.tsx";

const OutboundTable = () => {
  const { selectedCompany } = useCompany();

  if (!selectedCompany) {
    return (
      <Box p={4}>
        <Typography>Seleccione una compañía primero</Typography>
      </Box>
    );
  }

  const setStatusColor = (statusCode) => {
    switch (statusCode) {
      case "OUTBOUNDS_PENDING":
        return "warning";
      case "OUTBOUNDS_DELIVERED":
        return "success";
      case "OUTBOUNDS_REJECTED":
        return "error";
    }
  };


  const outboundCrudProps = {
    fetchFunction: getOutboundList,
    deleteFunction: deleteOutbound,
    data: { companyId: selectedCompany.id },
    detailMenu: [
      {
        label: "Cambiar Estatus",
        handler: () => { },
        header: "Entregar Salida",
        body: (
          <StatusManager
            updateFunction={updateOutboundStatus}
            catalogueName="OUTBOUNDS"
            fieldName="statusId"
          />
        ),
      },
    ],
    columns: [
      { field: "code", headerName: "Folio", flex: 0.1 },
      { field: "workOrder", headerName: "Orden de Trabajo", flex: 0.2 },
      {
        field: "warehouseOrigin",
        headerName: "Almacén Origen",
        flex: 0.2,
        valueGetter: (value, row) => {
          return row.warehouseOrigin ? row.warehouseOrigin.name : "-";
        },
      },
      {
        field: "outboundItems",
        headerName: "Artículos",
        flex: 0.3,
        renderCell: (params) => {
          const items = params.row.outboundItems || [];
          return (
            <Stack direction="column" spacing={1} flexWrap="wrap">
              {items.map((item: any, index: number) => (
                <Box key={index} sx={{ display: "flex", alignItems: "center" }}>
                  <Typography variant="caption" sx={{ mr: 1 }}>
                    {item.quantity} x
                  </Typography>
                  <Typography variant="caption" noWrap>
                    {item.product ? item.product.description || item.product.code : "-"}
                  </Typography>
                </Box>
              ))}
            </Stack>
          );
        },
      },
      {
        field: "plantDestination",
        headerName: "Planta Destino",
        flex: 0.2,
        valueGetter: (value, row) => {
          return row.plantDestination ? row.plantDestination.name : "-";
        },
      },
      { field: "requestedBy", headerName: "Solicitado Por", flex: 0.2 },
      { field: "deliveredBy", headerName: "Entregado Por", flex: 0.2 },
      {
        field: "statusId",
        headerName: "Estado",
        flex: 0.2,
        renderCell: (params) => {
          const status = params.row.status;
          const statusCode = status ? status.code : "-";
          const statusName = status ? status.name.toUpperCase() : "-";
          const statusColor = setStatusColor(statusCode);

          return (
            <Box
              mt={2}
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <Chip
                size="small"
                label={statusName}
                color={statusColor}
              />
            </Box>
          );
        },
      },
      {
        field: "createdAt",
        headerName: "Fecha de Creación",
        flex: 0.1,
        valueFormatter: (value) => {
          if (!value) return "-";
          return dayjs(value).format("YYYY-MM-DD");
        },
      },
      { field: "completedDate", headerName: "Fecha de Completado", flex: 0.1 },
    ],
    addModalData: {
      header: "Nueva Salida",
      body: <OutboundForm onSubmit={() => { }} />,
    },
    editModalData: {
      header: "Editar Salida",
      body: <OutboundForm onSubmit={() => { }} />,
    },
    actions: ["create", "detail", "delete"],
    customButtons: [],
  };

  return <LGModalCrud props={outboundCrudProps} />;
};

export default OutboundTable;
